import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import type { Theme } from "@/theme/CreateTheme.ts";
import { Page } from "@/uiKit/atoms/page/Page.tsx";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";
import { PageHeader } from "@/uiKit/atoms/page/PageHeader.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { PatientSyncPlatforms } from "@/uiKit/organisms/PatientSync/PatientSyncIndex/PatientSyncPlatforms.tsx";

export const PatientSyncPage: React.FC = () => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Page id="PatientSyncPage" className={styles.container}>
      <PageHeader />
      <PageContent className={styles.content}>
        <Typography variant="body">{t("patientSync.index.intro")}</Typography>
        <PatientSyncPlatforms />
      </PageContent>
    </Page>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({}),
  content: css({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(8),
  }),
});
